import {useSubheader} from "../../../_metronic/layout";
import React, {useEffect, useRef, useState} from "react";
import {useFormik} from "formik";
import * as Yup from "yup";
import {useHistory} from "react-router-dom";
import makeRequest from "../../api/makeRequest";
import {useAlert} from "react-alert";
import {useTranslation} from "react-i18next";
import apiConfig from "../../config/apiConfig";


const defInitialValues = {
	"name": "",
	"duration": 10,
	"max_user": 50,
	"max_time": 100000,
	"slug": '',
	"host_start": false,
	"has_guest": false,
};

export const EditRoomPage = ({match}) => {
	const { t } = useTranslation('common');
	const {id: ID} = match.params
	const suhbeader = useSubheader();
	suhbeader.setTitle(t('EditRoom'));

	const initialValues = useRef(defInitialValues)

	const alert = useAlert()

	useEffect(() => {
		enableLoading();
		makeRequest('getRoom', {
			"id": ID,
		}).then(({data}) => {
			if (data.success) {
				initialValues.current = data.room
			} else {
				const {error} = data
				alert.error(error)
			}
		}).catch(() => {
			alert.error(t('Error'))
		})
			.finally(() => {
				disableLoading();
			})
	}, [])

	const [loading, setLoading] = useState(false);
	const [okMessage, setOkMessage] = useState('');
	const LoginSchema = Yup.object().shape({
		name: Yup.string()
			.required(
				t('PleaseName')
			),
		slug: Yup.string()
			.optional(),
		duration: Yup.number()
			.required(
				t('PleaseTime')
			),
		max_user: Yup.number()
			.required(
				t('PleaseCapacity')
			),
		max_time: Yup.number()
			.required(
				t('PleasePerson')
			),
		host_start: Yup.boolean(),
		has_guest: Yup.boolean(),
	});

	const enableLoading = () => {
		setLoading(true);
	};

	const disableLoading = () => {
		setLoading(false);
	};

	const getInputClasses = (fieldname) => {
		if (formik.touched[fieldname] && formik.errors[fieldname]) {
			return "is-invalid";
		}

		if (formik.touched[fieldname] && !formik.errors[fieldname]) {
			return "is-valid";
		}

		return "";
	};

	let history = useHistory();

	const formik = useFormik({
		enableReinitialize: true,
		initialValues: {
			...initialValues.current,
			duration:initialValues.current.duration/60
		},
		validationSchema: LoginSchema,
		onSubmit: async (values, {setStatus, setSubmitting}) => {
			enableLoading();
			makeRequest('editRoom', {
				"id":ID,
				"name": values.name,
				"duration": values.duration * 60,
				"max_user": values.max_user,
				"max_time": values.max_time,
				"host_start": values.host_start,
				"has_guest": values.has_guest,
				"slug": values.slug,
			}).then(({data}) => {
				const {success} = data
				if (success) {
					setOkMessage(t('RoomBuiltEdit'))
					setTimeout(() => {
						history.push('/room')
					}, 1000)
				} else {
					const {error} = data
					setSubmitting(false);
					setStatus(error)
				}
			}).catch((e) => {
				setSubmitting(false);
				setStatus(t('Error'))
			}).finally(() => {
				disableLoading();
			})
		},
	});

	return (
		<>
			<form
				onSubmit={formik.handleSubmit}
				className="form fv-plugins-bootstrap fv-plugins-framework"
			>
				{formik.status ? (
					<div className="mb-10 alert alert-custom alert-light-danger alert-dismissible">
						<div className="alert-text font-weight-bold">{formik.status}</div>
					</div>
				) : null}
				{okMessage ? (
					<div className="mb-10 alert alert-custom alert-light-success alert-dismissible">
						<div className="alert-text font-weight-bold">{okMessage}</div>
					</div>
				) : null}

				<div className="form-group fv-plugins-icon-container">
					<label>{t('RoomName')}</label>
					<input
						placeholder={t('Name')}
						type="text"
						className={`form-control form-control-solid h-auto py-5 px-6 ${getInputClasses(
							"name"
						)}`}
						name="name"
						{...formik.getFieldProps("name")}
					/>
					{formik.touched.name && formik.errors.name ? (
						<div className="fv-plugins-message-container">
							<div className="fv-help-block">{formik.errors.name}</div>
						</div>
					) : null}
				</div>
				<div className="form-group fv-plugins-icon-container">
					<label>{t('PrivateLink')}</label>
					<input
						placeholder={'my-webinar'}
						type="text"
						className={`form-control form-control-solid h-auto py-5 px-6 ${getInputClasses(
							"slug"
						)}`}
						name="slug"
						{...formik.getFieldProps("slug")}
					/>
					{formik.touched.slug && formik.errors.slug ? (
						<div className="fv-plugins-message-container">
							<div className="fv-help-block">{formik.errors.slug}</div>
						</div>
					) : null}
					<div className="fv-plugins-message-container">
						<div className="fv-help-block" style={{
							direction: "ltr",
							color: "#505050",
							fontWeight: "bold",
							textAlign: "left"
						}}>
							{`${apiConfig.BASE_URL}w/`}<span style={{color:"#9e9e9e"}} >Your_Service_ID</span>/<span style={{color:"#2196f3"}}>{`${formik.values.slug ? formik.values.slug : '*'}`}</span>
						</div>
					</div>
				</div>
				<div className="form-group fv-plugins-icon-container">
					<label>{t('Time')} 0 = {t('Infinity')} </label>
					<input
						placeholder={t('RoomTime')}
						type="number"
						className={`form-control form-control-solid h-auto py-5 px-6 ${getInputClasses(
							"duration"
						)}`}
						name="duration"
						{
							...formik.getFieldProps("duration")

						}
					/>
					{formik.touched.duration && formik.errors.duration ? (
						<div className="fv-plugins-message-container">
							<div className="fv-help-block">{formik.errors.duration}</div>
						</div>
					) : null}
				</div>
				<div className="form-group fv-plugins-icon-container">
					<label>{t('CapacityNumber')}</label>
					<input
						placeholder={t('Capacity')}
						type="number"
						className={`form-control form-control-solid h-auto py-5 px-6 ${getInputClasses(
							"max_user"
						)}`}
						name="max_user"
						{...formik.getFieldProps("max_user")}
					/>
					{formik.touched.max_user && formik.errors.max_user ? (
						<div className="fv-plugins-message-container">
							<div className="fv-help-block">{formik.errors.max_user}</div>
						</div>
					) : null}
				</div>
				{/*<div className="form-group fv-plugins-icon-container">
					<label>نفر دقیقه</label>
					<input
						placeholder="حداکثر نفر/دقیقه"
						type="number"
						className={`form-control form-control-solid h-auto py-5 px-6 ${getInputClasses(
							"max_time"
						)}`}
						name="max_time"
						{...formik.getFieldProps("max_time")}
					/>
					{formik.touched.max_time && formik.errors.max_time ? (
						<div className="fv-plugins-message-container">
							<div className="fv-help-block">{formik.errors.max_time}</div>
						</div>
					) : null}
				</div>*/}
				<div className="form-group fv-plugins-icon-container">
					<label>{t('StartWithMaster')}</label>
					<input
						placeholder="شروع استاد ؟"
						type="checkbox"
						className={`form-control text-center form-control-solid h-auto py-5 px-6 w-auto mx-10 d-inline-block ${getInputClasses(
							"host_start"
						)}`}
						name="host_start"
						checked={formik.getFieldProps("host_start").value}
						{...formik.getFieldProps("host_start")}
					/>
					{formik.touched.host_start && formik.errors.host_start ? (
						<div className="fv-plugins-message-container">
							<div className="fv-help-block">{formik.errors.host_start}</div>
						</div>
					) : null}
				</div>
				<div className="form-group fv-plugins-icon-container">
					<label>{t('GuestRoom')}</label>
					<input
						placeholder="دارای مهمان ؟"
						type="checkbox"
						className={`form-control text-center form-control-solid h-auto py-5 px-6 w-auto mx-10 d-inline-block  ${getInputClasses(
							"has_guest"
						)}`}
						name="has_guest"
						checked={formik.getFieldProps("has_guest").value}
						{...formik.getFieldProps("has_guest")}
					/>
					{formik.touched.has_guest && formik.errors.has_guest ? (
						<div className="fv-plugins-message-container">
							<div className="fv-help-block">{formik.errors.has_guest}</div>
						</div>
					) : null}
				</div>
				<div className="form-group d-flex flex-wrap justify-content-between align-items-center">
					<button
						id="kt_login_signin_submit"
						type="submit"
						disabled={formik.isSubmitting}
						className={`btn btn-primary font-weight-bold px-9 py-4 my-3`}
					>
						<span>{t('Edit')}</span>
						{loading && <span className="blockui m-1 ml-3 spinner spinner-white"/>}
					</button>
				</div>
			</form>
		</>
	)
}
